/**
 * TOP リニューアル（2026-07）専用スクリプト
 * 出自: 30_coding/assets/js/main.js + animation.js + waves.js を1ファイルにまとめたもの。
 * Shopify 移植による差分は2点。
 *   ・企業理念ギャラリーの Swiper 初期化を足した
 *   ・ヘッダー／ドロワーの開閉は全ページで必要なため
 *     custom-202607-common.js へ切り出した
 * index テンプレートでのみ読み込む。
 */

/* ==========================================================================
   1. 機能（横スクロール / アコーディオン / 企業理念スライダー）
      ※ドロワー開閉は custom-202607-common.js
   ========================================================================== */

document.addEventListener("DOMContentLoaded", () => {
  const bindHorizontalControls = (trackSelector, previousSelector, nextSelector) => {
    const track = document.querySelector(trackSelector);
    const previousButton = document.querySelector(previousSelector);
    const nextButton = document.querySelector(nextSelector);

    if (!track || !previousButton || !nextButton) {
      return;
    }

    const scrollTrack = (direction) => {
      const firstItem = track.firstElementChild;
      const itemWidth = firstItem?.getBoundingClientRect().width ?? track.clientWidth;
      const computedStyle = window.getComputedStyle(track);
      const gap = Number.parseFloat(computedStyle.columnGap) || 0;
      track.scrollBy({
        left: direction * (itemWidth + gap),
        behavior: "smooth",
      });
    };

    previousButton.addEventListener("click", () => scrollTrack(-1));
    nextButton.addEventListener("click", () => scrollTrack(1));
  };

  bindHorizontalControls(
    ".top-works__track",
    ".top-works__control--prev",
    ".top-works__control--next",
  );
  bindHorizontalControls(
    ".top-flow__track",
    ".top-flow__control--prev",
    ".top-flow__control--next",
  );

  const flowTrack = document.querySelector(".top-flow__track");
  const flowProgress = document.querySelector(".top-flow__progress-bar");
  const progressClasses = [
    "top-flow__progress-bar--40",
    "top-flow__progress-bar--60",
    "top-flow__progress-bar--80",
    "top-flow__progress-bar--100",
  ];

  const updateFlowProgress = () => {
    if (!flowTrack || !flowProgress) {
      return;
    }

    const maximumScroll = flowTrack.scrollWidth - flowTrack.clientWidth;
    const progress = maximumScroll > 0 ? flowTrack.scrollLeft / maximumScroll : 0;
    const progressStep = Math.min(4, Math.ceil(progress * 4));

    flowProgress.classList.remove(...progressClasses);
    if (progressStep > 0) {
      flowProgress.classList.add(progressClasses[progressStep - 1]);
    }
  };

  flowTrack?.addEventListener("scroll", updateFlowProgress, { passive: true });
  window.addEventListener("resize", updateFlowProgress);
  updateFlowProgress();

  const faqItems = document.querySelectorAll(".top-faq__item");
  faqItems.forEach((item) => {
    item.addEventListener("toggle", () => {
      if (!item.open) {
        return;
      }

      faqItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.open = false;
        }
      });
    });
  });

  /* 画像スライダー（汎用セクション custom-202607-gallery-slider）
     もとは企業理念に内包していたギャラリー。設定は現行テーマ（custom.js）のまま。
     等速で流し続け、手動スワイプはさせない。スライドが1枚以下なら回さない。

     1ページに複数置ける汎用セクションなので、querySelector（最初の1つだけ）ではなく
     querySelectorAll で全件を回す。Swiper には要素そのものを渡しているため、
     セレクタ文字列を渡したときのように別のスライダーを掴むことはない。
     Swiper は theme.liquid で先に読み込まれている。 */
  if (typeof Swiper !== "undefined") {
    document.querySelectorAll(".c-gallery-slider__track").forEach((gallery) => {
      const slideCount = gallery.querySelectorAll(".swiper-slide").length;

      if (slideCount <= 1) {
        return;
      }

      new Swiper(gallery, {
        loop: true,
        slidesPerView: 1.3,
        spaceBetween: 0,
        speed: 10000,
        allowTouchMove: false,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        breakpoints: {
          768: {
            slidesPerView: 2.5,
          },
        },
      });
    });
  }
});

/* ==========================================================================
   2. モーション
   ========================================================================== */

/**
 * モーション層
 * main.js（機能）とは分離し、動きだけをここで扱う。
 * ・スクロールリビール（既存の data-anim="fade-up" フックを使う）
 * ・ヒーロー縦書きキャッチの1文字リビール
 * ・セクション英語ラベルのマスク上げ
 * ・パララックス（背景画像・写真の内側移動）
 * ・ヒーローのスクロールアウト
 * ・数字のカウントアップ
 *
 * prefers-reduced-motion: reduce の環境では初期化そのものを行わない。
 */

/* リビールで要素を隠すのは、この層が確実に動いているときだけにする。
   JS が落ちた・IntersectionObserver が無い環境で opacity:0 のまま残ると
   本文が永久に読めなくなるため、隠す指定自体を html.js に閉じ込める。 */
document.documentElement.classList.add("js");

document.addEventListener("DOMContentLoaded", () => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  const revealAll = () => {
    document.querySelectorAll("[data-anim], .c-section-headline, .top-hero__headline, .top-results__card")
      .forEach((element) => element.classList.add("is-visible"));
  };

  /* ------------------------------------------------------------------
     運用実績の棒グラフ
     data-bar（0〜100）から高さを組み立てる。モーション低減の指定があっても
     グラフ自体は情報なので、高さは必ず設定する（伸びる演出だけを止める）。
     ------------------------------------------------------------------ */
  const setupBars = () => {
    document.querySelectorAll("[data-bar]").forEach((bar) => {
      const value = Number(bar.dataset.bar);

      if (!Number.isFinite(value)) {
        return;
      }

      bar.style.setProperty("--bar-height", `${Math.max(0, Math.min(100, value))}%`);
    });
  };

  setupBars();

  if (reduceMotion.matches) {
    revealAll();
    return;
  }

  // IntersectionObserver が使えない環境ではすべて表示しておく
  if (!("IntersectionObserver" in window)) {
    revealAll();
    return;
  }

  /* ------------------------------------------------------------------
     ヒーローのキャッチを1文字ずつに割る
     読み上げは aria-label に元テキストを残し、分割後の span は隠す。
     ------------------------------------------------------------------ */
  const splitHeadline = () => {
    const headline = document.querySelector(".top-hero__headline");

    if (!headline || headline.dataset.split === "done") {
      return;
    }

    const plainText = headline.textContent.trim();
    const source = Array.from(headline.childNodes);
    const fragment = document.createDocumentFragment();
    let index = 0;

    const appendCharacter = (target, character) => {
      const span = document.createElement("span");
      // 約物（かぎ括弧・句読点）はアキが目立つので詰める用の修飾子を付ける
      const isBracket = /[「」『』（）]/.test(character);
      span.className = isBracket ? "js-char js-char--bracket" : "js-char";
      span.textContent = character;
      span.style.setProperty("--char-delay", `${0.25 + index * 0.055}s`);
      target.appendChild(span);
      index += 1;
    };

    source.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === "BR") {
        fragment.appendChild(node.cloneNode());
        return;
      }

      if (node.nodeType !== Node.TEXT_NODE) {
        return;
      }

      /* 1文字ずつを inline-block にすると文字間がすべて改行位置になり、
         横組みでは欧字が「E / C」のように語の途中で割れる。
         セクション英語ラベルと同じく欧字の連なりだけ span でくくって
         nowrap を掛け、折り返せる場所から外す。和文は1文字ずつのまま。 */
      node.textContent.split(/([A-Za-z0-9]+)/).forEach((chunk) => {
        if (chunk === "") {
          return;
        }

        if (/^[A-Za-z0-9]+$/.test(chunk)) {
          const word = document.createElement("span");
          word.className = "js-word";
          Array.from(chunk).forEach((character) => appendCharacter(word, character));
          fragment.appendChild(word);
          return;
        }

        Array.from(chunk).forEach((character) => appendCharacter(fragment, character));
      });
    });

    headline.setAttribute("aria-label", plainText);
    headline.replaceChildren(fragment);
    Array.from(headline.children).forEach((child) => {
      child.setAttribute("aria-hidden", "true");
    });
    headline.dataset.split = "done";
  };

  /* ------------------------------------------------------------------
     セクション英語ラベルを1文字ずつに割る
     語ごと持ち上げるより、文字が順に立ち上がるほうが手数がかかって見える。
     グラデーションはラベル（親）側に掛かったままなので、文字を分けても
     語をまたいだ色の連なりは崩れない。
     見出し以外では aria-label を使えないため、読み上げ用テキストを別に残す。
     ------------------------------------------------------------------ */
  const splitLabels = () => {
    document.querySelectorAll(".c-section-headline__en").forEach((label) => {
      if (label.dataset.split === "done") {
        return;
      }

      const plainText = label.textContent.trim();
      const fragment = document.createDocumentFragment();
      let index = 0;

      /* 1文字ずつを inline-block にしているため、そのまま並べると文字と文字の
         あいだがすべて改行位置になり、「Your Conce / rns」のように語の途中で
         折り返してしまう。語ごとに span でくくって nowrap を掛け、
         折り返せる場所を語の切れ目だけに限定する。 */
      plainText.split(/(\s+)/).forEach((chunk) => {
        if (chunk === "") {
          return;
        }

        // 語間は普通の半角スペースのまま残す。ここが唯一の改行候補になる。
        if (/^\s+$/.test(chunk)) {
          fragment.appendChild(document.createTextNode(" "));
          return;
        }

        const word = document.createElement("span");
        word.className = "js-word";
        word.setAttribute("aria-hidden", "true");

        Array.from(chunk).forEach((character) => {
          const span = document.createElement("span");
          span.className = "js-char";
          span.textContent = character;
          span.style.setProperty("--char-delay", `${index * 0.045}s`);
          word.appendChild(span);
          index += 1;
        });

        fragment.appendChild(word);
      });

      if (label.matches("h1, h2, h3, h4, h5, h6")) {
        label.setAttribute("aria-label", plainText);
        label.replaceChildren(fragment);
      } else {
        const screenReaderText = document.createElement("span");
        screenReaderText.className = "sr-only";
        screenReaderText.textContent = plainText;

        // 表示用文字を一括で隠し、sr-only は文字アニメーションの連番に含めない。
        const visualText = document.createElement("span");
        visualText.setAttribute("aria-hidden", "true");
        visualText.appendChild(fragment);

        label.removeAttribute("aria-label");
        label.replaceChildren(screenReaderText, visualText);
      }
      label.dataset.split = "done";
    });
  };

  /* ------------------------------------------------------------------
     リビール監視
     同じ親を持つ兄弟には段差（stagger）を付ける。
     ------------------------------------------------------------------ */
  const setupReveal = () => {
    const targets = [
      ...document.querySelectorAll("[data-anim]"),
      ...document.querySelectorAll(".c-section-headline"),
      ...document.querySelectorAll(".top-hero__headline"),
      ...document.querySelectorAll(".top-results__card"),
    ];

    const groups = new Map();
    document.querySelectorAll("[data-anim]").forEach((element) => {
      const parent = element.parentElement;

      if (!parent) {
        return;
      }

      const siblings = groups.get(parent) ?? [];
      siblings.push(element);
      groups.set(parent, siblings);
    });

    groups.forEach((siblings) => {
      if (siblings.length < 2) {
        return;
      }

      siblings.forEach((element, order) => {
        element.style.setProperty("--anim-delay", `${order * 0.12}s`);
      });
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" },
    );

    new Set(targets).forEach((element) => observer.observe(element));

    /* 保険。アンカーでページ途中に着地した場合や、監視が取りこぼした場合に
       画面より上にある要素が隠れたまま残らないようにする。 */
    const sweep = () => {
      new Set(targets).forEach((element) => {
        if (element.classList.contains("is-visible")) {
          return;
        }

        if (element.getBoundingClientRect().top < window.innerHeight) {
          element.classList.add("is-visible");
          observer.unobserve(element);
        }
      });
    };

    window.setTimeout(sweep, 2500);
    window.addEventListener("load", () => window.setTimeout(sweep, 400));
  };

  /* ------------------------------------------------------------------
     パララックス
     可視範囲に入っている要素だけを rAF で更新する。
     amount = 画面を通過する間に動かす総量(px)。値が小さいほど奥に見える。
     ------------------------------------------------------------------ */
  const setupParallax = () => {
    const layers = [
      { selector: ".top-business", amount: 60 },
      { selector: ".c-footer", amount: 40 },
      // 円の枠からはみ出せる量は (228 × 0.12) ÷ 2 ＝ 約13px しかない。
      // これを超えて動かすと円の縁に地が見えるので、移動量は 10px に抑える。
      { selector: ".top-greeting__portrait img", amount: 10 },
    ];

    const items = [];
    layers.forEach((layer) => {
      document.querySelectorAll(layer.selector).forEach((element) => {
        items.push({ element, amount: layer.amount, visible: false });
      });
    });

    if (items.length === 0) {
      return;
    }

    const visibilityObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const item = items.find((candidate) => candidate.element === entry.target);

          if (item) {
            item.visible = entry.isIntersecting;
          }
        });
      },
      { rootMargin: "20% 0px 20% 0px" },
    );

    items.forEach((item) => visibilityObserver.observe(item.element));

    const hero = document.querySelector(".top-hero");
    const opening = document.querySelector(".top-opening");
    const openingImage = document.querySelector(".top-opening__image");
    const openingNoise = document.querySelector(".top-opening__noise");
    const philosophy = document.querySelector(".top-philosophy");
    const consult = document.querySelector(".top-consult");
    const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
    let ticking = false;

    /* オープニング（ヒーロー〜こんなご相談）の共通背景。
       背景層は sticky で画面に留まるため、要素自身の位置ではなく
       オープニング全体のスクロール進捗（0→1）で動かす。 */
    const updateOpening = (viewportHeight) => {
      if (!opening) {
        return;
      }

      const rect = opening.getBoundingClientRect();
      const travel = Math.max(1, rect.height - viewportHeight);
      const progress = clamp(-rect.top / travel, 0, 1);

      if (openingImage) {
        openingImage.style.setProperty("--parallax-y", `${(progress * 130 - 65).toFixed(2)}px`);
      }

      if (openingNoise) {
        openingNoise.style.setProperty("--parallax-y", `${(progress * -70 + 35).toFixed(2)}px`);
      }

      // 企業理念のガラスは、セクションが入ってくるほど強く効かせる。
      // 一定の値で敷きっぱなしにすると、始まる位置が直線の境目として見えてしまう。
      if (philosophy) {
        const philosophyRect = philosophy.getBoundingClientRect();
        const glass = clamp((viewportHeight - philosophyRect.top) / (viewportHeight * 0.85), 0, 1);
        philosophy.style.setProperty("--glass-progress", glass.toFixed(3));
      }

      if (!consult) {
        return;
      }

      // 「こんなご相談」が入ってくるほど暗く、抜けて企業理念に近づくと元へ戻す
      const consultRect = consult.getBoundingClientRect();
      // ヒーローを見ている間は暗くしない。相談セクションが画面の半分より上に来てから効かせる
      const enter = clamp((viewportHeight * 0.5 - consultRect.top) / (viewportHeight * 0.5), 0, 1);
      // 企業理念に入る手前で 0 に戻しきる
      const exit = clamp((consultRect.bottom - viewportHeight * 0.2) / (viewportHeight * 0.5), 0, 1);
      opening.style.setProperty("--opening-dim", (0.72 * enter * exit).toFixed(3));
    };

    const update = () => {
      const viewportHeight = window.innerHeight;

      items.forEach((item) => {
        if (!item.visible) {
          return;
        }

        const rect = item.element.getBoundingClientRect();
        const elementCenter = rect.top + rect.height / 2;
        // 画面中央を 0 とし、上下端で ±1 になる進捗
        const progress = (elementCenter - viewportHeight / 2) / (viewportHeight / 2 + rect.height / 2);
        const clamped = clamp(progress, -1, 1);
        item.element.style.setProperty("--parallax-y", `${(clamped * item.amount).toFixed(2)}px`);
      });

      updateOpening(viewportHeight);

      if (hero) {
        const heroHeight = hero.offsetHeight || viewportHeight;
        const heroProgress = clamp(window.scrollY / (heroHeight * 0.65), 0, 1);
        hero.style.setProperty("--hero-progress", heroProgress.toFixed(3));
      }

      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate);
    update();
  };

  /* ------------------------------------------------------------------
     数字のカウントアップ
     小数第一位まで動かす。整数で刻むと 1→2→3 と飛び飛びに見えて安っぽく、
     とくに 6.3倍 のような値は途中が嘘の数字になる。
     終わったら元の表記へ戻すので、2倍 は "2.0" ではなく "2" で止まる。
     data-count-delay（ミリ秒）で発火を個別に遅らせられる。
     ------------------------------------------------------------------ */
  const setupCounters = () => {
    const counters = document.querySelectorAll(
      ".top-works__lead-number, .top-reasons__emphasis, .top-results__figure-num",
    );

    if (counters.length === 0) {
      return;
    }

    const run = (element) => {
      const original = element.textContent.trim();
      const matched = original.match(/^(\D*)(\d+(?:\.\d+)?)(.*)$/);

      if (!matched) {
        return;
      }

      const [, prefix, digits, suffix] = matched;
      const goal = Number(digits);
      // 元が整数でも、動いている間は小数第一位まで見せる
      const decimals = Math.max(1, (digits.split(".")[1] || "").length);
      const duration = 1100;
      const start = performance.now();

      element.classList.add("js-count");

      const step = (now) => {
        const elapsed = Math.min(1, (now - start) / duration);
        // ease-out（cubic-bezier(.16,1,.3,1) に近い減速）
        const eased = 1 - Math.pow(1 - elapsed, 3);
        element.textContent = `${prefix}${(goal * eased).toFixed(decimals)}${suffix}`;

        if (elapsed < 1) {
          window.requestAnimationFrame(step);
        } else {
          element.textContent = original;
        }
      };

      window.requestAnimationFrame(step);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          const element = entry.target;
          observer.unobserve(element);

          const delay = Number(element.dataset.countDelay) || 0;

          if (delay > 0) {
            window.setTimeout(() => run(element), delay);
          } else {
            run(element);
          }
        });
      },
      { threshold: 0.6 },
    );

    counters.forEach((counter) => observer.observe(counter));
  };

  /* ここから先で例外が出ると、隠す指定（html.js）だけが残って本文が
     永久に読めなくなる。落ちたら隠す指定を外して全部出す。 */
  try {
    splitHeadline();
    splitLabels();
    setupReveal();
    setupParallax();
    setupCounters();
  } catch (error) {
    document.documentElement.classList.remove("js");
    revealAll();
    throw error;
  }
});

/* ==========================================================================
   3. 波と光の背景（オープニング）
   ========================================================================== */

/**
 * 波と光の背景
 *
 * オープニング（ヒーロー〜このようなお困り）の背景に、ゆっくり揺れる光の波を描く。
 * 動画やライブラリは使わず canvas 2D だけで組んでいる。
 *
 * 考え方:
 * ・1本の波は複数の正弦波を重ねて作る。周期をわざと割り切れない比にすることで、
 *   同じ形の繰り返しに見えない「ゆらぎ」が出る。
 * ・波は screen 合成で重ねる。光が溜まるところだけ明るくなり、絵の具のように濁らない。
 * ・色は白瑛の低彩度ブルー階調のみ。原色は使わない。
 * ・CSS 側で大きめにぼかすため、canvas は粗い解像度でよい（DPR は 1.25 で頭打ち）。
 */

(() => {
  const PALETTE = [
    { top: "rgba(57, 169, 242, 0.62)", bottom: "rgba(57, 169, 242, 0)" },
    { top: "rgba(220, 235, 244, 0.78)", bottom: "rgba(220, 235, 244, 0)" },
    { top: "rgba(255, 255, 255, 0.72)", bottom: "rgba(255, 255, 255, 0)" },
    { top: "rgba(127, 185, 224, 0.56)", bottom: "rgba(127, 185, 224, 0)" },
    { top: "rgba(236, 243, 248, 0.62)", bottom: "rgba(236, 243, 248, 0)" },
  ];

  // baseY / amplitude は画面高さに対する比率。速度は 1 秒あたりの位相の進み。
  const BANDS = [
    { baseY: 0.30, amplitude: 0.075, wavelength: 1.35, speed: 0.055, drift: 0.018, color: 0 },
    { baseY: 0.46, amplitude: 0.105, wavelength: 0.95, speed: -0.040, drift: 0.024, color: 1 },
    { baseY: 0.58, amplitude: 0.070, wavelength: 1.75, speed: 0.031, drift: 0.014, color: 2 },
    { baseY: 0.70, amplitude: 0.125, wavelength: 0.72, speed: -0.024, drift: 0.030, color: 3 },
    { baseY: 0.84, amplitude: 0.086, wavelength: 1.15, speed: 0.019, drift: 0.020, color: 4 },
  ];

  const canvas = document.querySelector(".top-opening__waves");

  if (!canvas || !canvas.getContext) {
    return;
  }

  const context = canvas.getContext("2d", { alpha: true });
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let width = 0;
  let height = 0;
  let ratio = 1;
  let visible = true;
  let running = false;
  let startTime = 0;

  const resize = () => {
    const rect = canvas.getBoundingClientRect();

    if (rect.width === 0 || rect.height === 0) {
      return;
    }

    ratio = Math.min(window.devicePixelRatio || 1, 1.25);
    width = Math.round(rect.width);
    height = Math.round(rect.height);
    canvas.width = Math.round(width * ratio);
    canvas.height = Math.round(height * ratio);
    context.setTransform(ratio, 0, 0, ratio, 0, 0);
  };

  /* 1本ぶんの波形。3つの正弦波を重ねて、繰り返しに見えない形にする。 */
  const waveY = (band, x, time) => {
    const phase = time * band.speed;
    const k = (Math.PI * 2) / (width * band.wavelength);
    const primary = Math.sin(x * k + phase * Math.PI * 2);
    const secondary = Math.sin(x * k * 2.37 - phase * Math.PI * 2.6) * 0.42;
    const tertiary = Math.sin(x * k * 0.61 + phase * Math.PI * 1.3) * 0.28;
    const swell = Math.sin(time * band.drift * Math.PI * 2) * 0.35 + 1;

    return (
      height * band.baseY +
      (primary + secondary + tertiary) * height * band.amplitude * swell
    );
  };

  const drawBand = (band, time) => {
    const color = PALETTE[band.color];
    const step = Math.max(8, Math.round(width / 90));

    context.beginPath();
    context.moveTo(0, waveY(band, 0, time));

    for (let x = step; x <= width; x += step) {
      context.lineTo(x, waveY(band, x, time));
    }

    context.lineTo(width, height);
    context.lineTo(0, height);
    context.closePath();

    const gradient = context.createLinearGradient(0, height * band.baseY - height * 0.16, 0, height);
    gradient.addColorStop(0, color.top);
    gradient.addColorStop(1, color.bottom);
    context.fillStyle = gradient;
    context.fill();
  };

  const render = (time) => {
    context.clearRect(0, 0, width, height);
    context.globalCompositeOperation = "screen";
    BANDS.forEach((band) => drawBand(band, time));
    context.globalCompositeOperation = "source-over";
  };

  const frame = (now) => {
    if (!running) {
      return;
    }

    if (!startTime) {
      startTime = now;
    }

    render((now - startTime) / 1000);
    window.requestAnimationFrame(frame);
  };

  const start = () => {
    if (running || reduceMotion.matches) {
      return;
    }

    running = true;
    window.requestAnimationFrame(frame);
  };

  const stop = () => {
    running = false;
    startTime = 0;
  };

  resize();

  if (reduceMotion.matches) {
    // 動かさないが、静止した波は描いておく（背景が単色になってしまわないように）
    render(0);
  } else {
    start();
  }

  // 画面から外れている間は描画を止める
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        visible = entry.isIntersecting;

        if (visible) {
          start();
        } else {
          stop();
        }
      });
    },
    { rootMargin: "10% 0px" },
  );

  observer.observe(canvas);

  /* 初期化時にレイアウトが未確定だと resize() が早期 return し、
     canvas が既定の 300x150 のまま取り残される。要素自身のサイズ変化を見て直す。 */
  if ("ResizeObserver" in window) {
    const sizeObserver = new ResizeObserver(() => {
      resize();

      if (!running) {
        render(0);
      }
    });
    sizeObserver.observe(canvas);
  }

  let resizeTimer = 0;
  window.addEventListener("resize", () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      resize();

      if (!running) {
        render(0);
      }
    }, 180);
  });

  reduceMotion.addEventListener("change", (event) => {
    if (event.matches) {
      stop();
      render(0);
    } else if (visible) {
      start();
    }
  });
})();
